<template>
  <div class="cgu">
    <div class="checkbox">
      <input type="checkbox" id="cgu" v-model="cgu" @change="cguChanged()">
      <label for="cgu" :class="{red: showCguAlert}">En cochant cette case, vous reconnaissez avoir pris connaissance de nos conditions générales d'utilisation pour cet outil en ligne dont vous utilisez les contenus (recommandations de traitement) sous votre entière responsabilité.</label>
    </div>
    <div class="u-color--red prevent-error">
      <img src="@/assets/img/icons.svg#icon-error" width="20" height="20">
      <span>Vous devez accepter les CGU pour pouvoir passer à l'étape suivante</span></div>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'

  export default {
    name: "Cgu",
    props: ['submitted'],
    data: () => ({
      cgu: false
    }),
    methods: {
      ...mapActions({
        setCguStatus: 'setCguStatus'
      }),
      cguChanged() {
        this.setCguStatus(this.cgu)
      }
    },
    computed: {
      ...mapGetters({
        getCguStatus: 'getCguStatus',
      }),
      showCguAlert() {
        return this.submitted && !this.getCguStatus
      }
    },
    mounted() {
      this.setCguStatus(this.cgu)
    }
  }
</script>

<style lang="scss">

  .cgu {
    display: flex;
    flex-direction: column;
    font-size: rem(12px);
    line-height: rem(18px);
    margin-top: rem(20px);
    padding-left: rem(20px);

    .checkbox {
      display: flex;
      flex-direction: row;

      label {
        color: color(grey-dark);
        &.red {
          color: red;
        }
      }

      /* Cachons la case à cocher */
      [type="checkbox"]:not(:checked),
      [type="checkbox"]:checked {
        position: absolute;
        left: rem(-9999px);
      }

      /* on prépare le label */
      [type="checkbox"]:not(:checked) + label,
      [type="checkbox"]:checked + label {
        position: relative;
        padding-left: rem(25px);
        cursor: pointer;
      }

      /* Aspect des checkboxes */
      /* :before sert à créer la case à cocher */
      [type="checkbox"]:not(:checked) + label:before,
      [type="checkbox"]:checked + label:before {
        content: '';
        position: absolute;
        left:0;
        top: 2px;
        width: 17px;
        height: 17px; /* dim. de la case */
        border: 2px solid color(red);
        background: white;
      }

      /* Aspect général de la coche */
      [type="checkbox"]:not(:checked) + label:after,
      [type="checkbox"]:checked + label:after {
        content: '✔';
        position: absolute;
        top: 0; left: 4px;
        font-size: rem(14px);
        color: color(red);
        transition: all .2s; /* on prévoit une animation */
      }
      /* Aspect si "pas cochée" */
      [type="checkbox"]:not(:checked) + label:after {
        opacity: 0; /* coche invisible */
        transform: scale(0); /* mise à l'échelle à 0 */
      }

      /* Aspect si "cochée" */
      [type="checkbox"]:checked + label:after {
        opacity: 1; /* coche opaque */
        transform: scale(1); /* mise à l'échelle 1:1 */
      }
    }

    .prevent-error {
      padding-left: rem(25px);
    }
  }

  .prevent-error {
    margin-top: rem(10px);
    display: flex;
    align-items: center;
    font-weight: 700;
    padding-left: rem(20px);

    img {
      margin-right: rem(10px);
    }
  }

</style>
